import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { IGetAuthorizationCredentialsApiResponse } from '../types/Credentials.api';

export const getAuthorizationCredentials = async (
  professionalId: string,
): Promise<IGetAuthorizationCredentialsApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetAuthorizationCredentialsApiResponse>(
    `/credential-service/professionals/${professionalId}/authorizations`,
    { headers },
  );

  return response.data;
};
